import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import SweetAlert from 'react-bootstrap-sweetalert'
import KapalService from '../../../../services/kapal/KapalService'

const ModalInspeksiChecklistHasil = ({ showHasilInspeksi, handleCloseHasilInspeksi, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [listChecklistCheck, setListChecklistCheck] = useState([])
    const [dataInspeksi, setDataInspeksi] = useState(null)
    const [isUnder5GT, setIsUnder5GT] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            try {
                let isOver5Gt = dataPpmKapal.ukuranKapal <= 5 ? 'T' : 'Y'
                let isPembeku = dataPpmKapal.fasilitasPembeku === '1' ? 'Y' : 'T'
                setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')

                const resChecklistCheck = await kapalService.checklistCek(isOver5Gt, isPembeku)
                setListChecklistCheck(resChecklistCheck.data.data)

                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setDataInspeksi(resDataInspeksi.data)

                }

            } catch (error) {

            }
        }
        fetchAllData()
    }, [dataPpmKapal, kapalService])

    const [showConfirmKirimHasil, setShowConfirmKirimHasil] = useState(false)
    const handleCloseConfirmHasil = () => {
        setShowConfirmKirimHasil(false)
    }

    const handleClickConfirmKirimHasil = () => {
        setShowConfirmKirimHasil(true)
    }

    const [showSendSuccess, setShowSendSucces] = useState(false)
    const [showSendFailed, setShowSendFailed] = useState(false)
    const [loadingSend, setLoadingSend] = useState(false)

    const handleClickSend = async () => {
        setLoadingSend(true)
        // setShowConfirmSend(false)
        try {
            // console.log(rowData)
            let jsonDisposisi = {
                nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                idDisposisi: 7,
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }

            const response = await kapalService.savePenugasan(jsonDisposisi)
            if (response.data.kode === '200') {

                let dataStatus = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: '024',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatus))

                dataStatus = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    kodeStatus: '025',
                    waktuStatus: new Date(),
                    createdBy: localStorage.getItem('userId')
                }
                await kapalService.saveKapalStatus(JSON.stringify(dataStatus))

                let jsonKapal = {
                    ...dataPpmKapal,
                    kodeStatus: '025',
                }
                await kapalService.saveKapalHeader(jsonKapal)

                setShowSendSucces(true)
                setShowConfirmKirimHasil(false)

            } else {
                setShowSendFailed(true)
                setShowConfirmKirimHasil(false)
            }
        } catch (error) {
            setShowSendFailed(true)
        }
        // console.log(noAju)
        setLoadingSend(false)
    }

    const handleClickSendSuccess = () => {
        setShowSendSucces(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickSendFailed = () => {
        setShowSendFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickClose = () => {
        handleCloseHasilInspeksi()
    }

    return (
        <>
            <Modal
                show={showHasilInspeksi}
                onHide={handleCloseHasilInspeksi}
                scrollable
                size='xl'
                centered
                backdrop='static'
            >
                <Modal.Header closeButton><h5>Hasil Inspeksi</h5></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Inspeksi</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="date" placeholder="NIB" className="form-control-sm" value={dataInspeksi && dataInspeksi.tglInspeksi} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-4'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-3'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="4">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Fasilitas Pembeku</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type='text' placeholder="alamat" className="form-control-sm" value={dataPpmKapal.fasilitasPembeku === '1' ? 'Dengan alat pembeku (freezer fishing vessel)' : 'Tanpa alat pembeku (non freezer fishing vessel)'} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <SummaryChecklist nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnde5Gt={isUnder5GT}/>
                    {
                        listChecklistCheck.map((check, idx) => {
                            return <DataHasilInspeksi kodeTipe={check.kodeTipe} nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnder5GT={isUnder5GT} />
                        })
                    }
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && dataPpmKapal.kodeStatus === '023' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmKirimHasil()}>Kirim Hasil Inspeksi Ke Pusat</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmKirimHasil &&
                <SweetAlert
                    title="Kirim Hasil Inspeksi ke Pusat?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSend ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Kirim...
                            </>
                        ) : (
                            "Kirim"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSend}
                    onCancel={handleCloseConfirmHasil}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSend}
                >
                    {loadingSend && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Kirim data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSendSuccess &&
                <SweetAlert
                    success
                    title="Kirim Data Berhasil"
                    onConfirm={handleClickSendSuccess}
                    btnSize="sm"
                />
            }
            {
                showSendFailed &&
                <SweetAlert
                    danger
                    title="Kirim Data Gagal"
                    onConfirm={handleClickSendFailed}
                    btnSize="sm"
                    timeout={2000}
                />

            }
        </>
    )
}

const DataHasilInspeksi = ({ kodeTipe, nomorAjuKapal, isUnder5GT }) => {
    let kapalService = useMemo(() => new KapalService(), [])
    const [listParam, setListParam] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resParam = await kapalService.checklistParamInspeksi(kodeTipe)
                setListParam(resParam.data.data)
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
    }, [kapalService, kodeTipe])

    return (
        <>
            {(loading && <Spinner />)}
            {listParam &&
                listParam.map((param, idx) => {
                    return (
                        <div className='row' key={idx}>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="10" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>{param.uraianParameterInspeksi}</b></Form.Label>
                                    </Form.Group>
                                </Form>
                            </div>
                            <div className='row'>
                                <Col sm="5">
                                    <Form.Label column sm="10" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Checklist</b></Form.Label>
                                </Col>
                                <Col sm="5">
                                    <Form.Label column sm="10" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Keterangan</b></Form.Label>
                                </Col>
                                <Col sm="2">
                                    <Form.Label column sm="10" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Kriteria Penyimpangan</b></Form.Label>
                                </Col>
                            </div>
                            <DetilHasilInspeksi kodeParameterInspeksi={param.kodeParameterInspeksi} nomorAjuKapal={nomorAjuKapal} isUnder5GT={isUnder5GT} />
                        </div>

                    )
                })
            }
        </>
    )
}

const DetilHasilInspeksi = ({ kodeParameterInspeksi, nomorAjuKapal, isUnder5GT }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [listHasil, setListHasil] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                const resHasil = await kapalService.listHasilInspeksi(nomorAjuKapal, kodeParameterInspeksi, isUnder5GT)
                setListHasil(resHasil.data.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, kodeParameterInspeksi, nomorAjuKapal, isUnder5GT])

    return (
        <>
            {
                listHasil &&
                listHasil.map((hasil, idx) => {
                    const valueHasil = (nilai) => {
                        if (isUnder5GT === 'Y') {
                            return 'Tidak Sesuai'
                        } else {
                            if (nilai === 1) {
                                return 'Kritis'
                            } else if (nilai === 2) {
                                return 'Mayor'
                            } else if (nilai === 3) {
                                return 'Minor'
                            }
                        }
                    }
                    return (
                        <>
                            <div className='row mb-2' key={idx}>
                                <Col sm="5">
                                    <Form.Control as='textarea' rows={5} className="form-control-sm" value={hasil.uraianTargetNilai} disabled />
                                </Col>
                                <Col sm="5">
                                    <Form.Control as='textarea' rows={5} className="form-control-sm" value={hasil.keterangan} disabled />
                                </Col>
                                <Col sm="2">
                                    <Form.Control type='text' placeholder="kriteria" className="form-control-sm" value={valueHasil(hasil.nilai)} disabled />
                                </Col>
                            </div>
                        </>
                    )
                })
            }
        </>
    )
}

const SummaryChecklist = ({ nomorAjuKapal, isUnde5Gt }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [dataSummary, setDataSummary] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                let response
                if (isUnde5Gt === 'Y') {
                    response = await kapalService.getSummaryChecklistSA(nomorAjuKapal)
                } else {
                    response = await kapalService.getSummaryChecklist(nomorAjuKapal)
                }
                setDataSummary(response.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, isUnde5Gt])

    return (
        <>
            {
                isUnde5Gt === 'Y' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-3'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Tidak Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahTidakSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
            {
                isUnde5Gt === 'T' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">OK</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahOk} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Minor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMinor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Mayor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMayor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Kritis</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahKritis} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">NA</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahNa} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalInspeksiChecklistHasil